module.exports = __webpack_public_path__ + "img/pieChart.9700ef44.svg";